import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class TbbsReclassService {
  constructor(private http: HttpClient) {}

  loadJson(baseUrl: string, params: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const body = new URLSearchParams();
    Object.keys(params || {}).forEach((k) => {
      const v = params[k];
      if (v !== undefined && v !== null) body.set(k, String(v));
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, body.toString(), { headers, withCredentials: true });
  }

  saveTBBSReclass(baseUrl: string, payload: any, accountArray: any[], globalParams: any, filterParams: any): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=usumyc`;
    let params: any = { ...filterParams };
    // Ensure required params from globalParams are present
    params.tax_year = globalParams?.tax_year || params.tax_year || '';
    params.scenario = globalParams?.scenario || params.scenario || '';
    params.jcd_key = globalParams?.jcd_key || params.jcd_key || '';
    // Merge remaining globalParams
    params = _.merge({}, globalParams || {}, params);
    // Ensure scenarioCode and is_issue_key_enabled from filterParams (set by AngularJS controller)
    if (filterParams?.scenarioCode) {
      params.scenarioCode = filterParams.scenarioCode;
    }
    if (filterParams?.is_issue_key_enabled) {
      params.is_issue_key_enabled = filterParams.is_issue_key_enabled;
    }
    params = _.extend({ jsonObj: JSON.stringify(accountArray || []) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(payload || {}) }, params);
    params.process_name = 'RECLASS_TBBS_SAVE';
    const body = new URLSearchParams();
    Object.keys(params).forEach((k) => {
      const v = params[k];
      if (v !== undefined && v !== null) body.set(k, String(v));
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, body.toString(), { headers, withCredentials: true });
  }

  deleteReclass(baseUrl: string, payload: any, globalParams: any, filterParams: any): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=ajxl4p`;
    let params: any = { ...filterParams };
    // Ensure required params from globalParams are present
    params.tax_year = globalParams?.tax_year || params.tax_year || '';
    params.scenario = globalParams?.scenario || params.scenario || '';
    params.jcd_key = globalParams?.jcd_key || params.jcd_key || '';
    // Merge remaining globalParams
    params = _.merge({}, globalParams || {}, params);
    // Ensure scenarioCode and is_issue_key_enabled from filterParams (set by AngularJS controller)
    if (filterParams?.scenarioCode) {
      params.scenarioCode = filterParams.scenarioCode;
    }
    if (filterParams?.is_issue_key_enabled) {
      params.is_issue_key_enabled = filterParams.is_issue_key_enabled;
    }
    params = _.extend({ jsonObj: JSON.stringify(payload || {}) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(payload || {}) }, params);
    params.process_name = 'RECLASS_TBBS_DELETE';
    const body = new URLSearchParams();
    Object.keys(params).forEach((k) => {
      const v = params[k];
      if (v !== undefined && v !== null) body.set(k, String(v));
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, body.toString(), { headers, withCredentials: true });
  }
}
